import Vue from 'vue';

export const EventBus = new Vue();

export function assets(data) {
    return `${window.location.origin}/${data}`
}

export function api(data) {
    return `${window.location.origin}/${data}`
}

// Pour les endpoints Laravel définis dans routes/api.php (préfixe /api)
export function apiV1(data) {
    const origin = window.location.origin;
    const path = String(data ?? '').replace(/^\/+/, '');
    return `${origin}/api/${path}`;
}

export function scheme() {
    return 'https://';
}

export function router(data) {
    return window.location.href = data
}

export function _buildQuery(params) {
    let string = '';

    for (let key in params) {
        if (params[key] !== "") {
            string += `${key}=${params[key]}&`
        }
    }
    string = '?' + string.substring(0, string.length - 1);
    return string;
}

export function format(num) {
    return num;
    //return String(num).replace(/(?<!\/..*)(\d)(?=(?:\d{3})+(?:\/.|$))/g, '$1 ');
}

export function uuidGen() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16)
    })
}
